<template>
  <v-dialog
    v-model="show"
    scrollable
    :persistent="dialog.lock"
    :max-width="dialog.width"
  >
    <v-card class="dialog">
      <v-card-title class="dialog__title">
        <v-icon class="mr-2" color="blue darken-2" large>mdi-message-text</v-icon>
        <span class="text-h5">{{ dialog.subject }}</span>
      </v-card-title>
      <v-card-text>
        <component v-if="typeof(dialog.content)=='object'" :is="dialog.content" ></component>
        <div class="dialog__content" v-else v-html="dialog.content"></div>
      </v-card-text>
      <v-card-actions :class="footerAlign" v-if="this.dialog.footer">
        <v-spacer></v-spacer>
        <DefaultButton
          :key="index"
          v-for="(item, index) in dialog.footer.actions"
          :colorType="item.color ? item.color : 'primary'"
          class="text__size-14"
          text
          @doFunction="doFunction(item)"
          height="auto"
        >
          <div class="btn-group__text"><span v-html="item.text"></span></div>
        </DefaultButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      dialog: {
        footer: {},
      },
      show: false,
    };
  },
  watch: {
    show(val) {
      this.setShow(val);
    },
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'dialog/showMessage') {
        this.dialog = state.dialog;
        this.show = true;
      }

      if (mutation.type === 'dialog/closeMessage') {
        this.show = false;
      }

      // return new Promise((resolve, reject) => {
      //   this.resolve = resolve;
      //   this.reject = reject;
      // });
    });
  },
  methods: {
    ...mapActions('dialog', ['setShow']),
    doFunction(item) {
      if (item.doFunction != null) item.doFunction();
    },

  },
  computed: {
    footerAlign() {
      if (this.dialog.footer.align === 'right') return 'align-self-start';
      if (this.dialog.footer.align === 'center') return 'align-self-center';

      return 'align-self-end';
    },
  },
};
</script>

<style lang="scss" scoped>

.dialog {
  background-color: white !important;
  background: url(~@/static/images/bg.jpg) top center no-repeat;
  &__title {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
  }
  &__content {
    white-space: pre-wrap;
  }

}

</style>
